import { cache } from 'react'
import type { CitiesContentResponse, CountryContentResponse, InvoiceCountries } from './types'
import { getConfig } from '@/tools/config'
import { fetcher } from '@/tools/fetcher'
import type { Language } from '@/tools/i18n'

export const getAllCitiesAndCountries = cache(async (language: Language) => {
  const { apiUrl } = getConfig()
  const response = await fetcher.get(`${apiUrl}/v3/cities/summarized_settings?language=${language}`)
  const allCities = Object.keys(response.data.cities).map((key) => ({
    code: key,
    name: response.data.cities[key].displayName,
  }))
  const allCountries = Object.keys(response.data.countries).map((key) => ({
    code: key,
    name: response.data.countries[key].name,
  }))
  return { cities: allCities, countries: allCountries }
})

export const getInvoiceCountry = async (): Promise<InvoiceCountries> => {
  const { apiUrl } = getConfig()
  const response = await fetcher.get(`${apiUrl}/v3/countries/invoice_settings`)
  return response.data
}

export const getCountryContent = cache(
  async ({ country, language }: { country: string; language: Language }) => {
    const { apiUrl } = getConfig()
    const response = await fetcher.get<CountryContentResponse>(
      `${apiUrl}/seo-content/locales/${language}/countries/${country}`
    )
    return response.data
  }
)

export const getCitiesContent = cache(
  async ({ country, language }: { country: string; language: Language }) => {
    const { apiUrl } = getConfig()
    const response = await fetcher.get<CitiesContentResponse>(
      `${apiUrl}/seo-content/locales/${language}/countries/${country}/cities`
    )
    return response.data
  }
)
